import { render, staticRenderFns } from "./OpenView.vue?vue&type=template&id=4e67323e&scoped=true"
import script from "./OpenView.vue?vue&type=script&lang=js"
export * from "./OpenView.vue?vue&type=script&lang=js"
import style0 from "./OpenView.vue?vue&type=style&index=0&id=4e67323e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e67323e",
  null
  
)

export default component.exports